import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class HomeComponent {
  constructor() {}
}
